import { render, staticRenderFns } from "./multi-choice-response.vue?vue&type=template&id=d7a43ab8&scoped=true&"
import script from "./multi-choice-response.vue?vue&type=script&lang=js&"
export * from "./multi-choice-response.vue?vue&type=script&lang=js&"
import style0 from "./multi-choice-response.vue?vue&type=style&index=0&id=d7a43ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a43ab8",
  null
  
)

component.options.__file = "multi-choice-response.vue"
export default component.exports